import { EntityType } from '$lib/sanity/types';
import groq from 'groq';
import { LinkReferenceFragment } from './link';

export const GetFooterQuery = groq`*[_type == "${EntityType.Footer}"]{
  ...,
  "companyLinks" : companyLinks[] {
    ${LinkReferenceFragment},
  },
  "buLinks" : buLinks[] {
    ${LinkReferenceFragment},
  },
  "socialLinks" : socialLinks[] {
    ${LinkReferenceFragment},
  },
}[0]`;
